import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import useScreenSize from '../../core/hooks/useScreenSize';
import { Icon } from '../common/Icons';
import CategoryLink from '../CategoryLink/CategoryLink';
import InfoTabs from '../InfoTabs/InfoTabs';
import {
  StyledContainer,
  StyledHeader,
  StyledHeading,
  StyledContentWrapper,
  StyledTitle,
  StyledSaveButton,
  StyledBackButton,
  StyledDescription,
} from './ExperienceInfo.styles';
import { useCallback, useEffect, useState } from 'react';
import { questionLike } from '../../core/service/questionLike.service';

function ExperienceInfo({ infoContent, questions, experienceName }) {
  const navigate = useNavigate();
  const [size] = useScreenSize();
  const onClick = useCallback(() => navigate(-1), []);

  // TODO: Delete block of code, from this:

  const [experienceId, setExperienceId] = useState(null);
  const [isLiked, setIsLiked] = useState(false);

  const updateIsLikeState = () => {
    JSON.parse(localStorage.getItem('likedExperiences')).indexOf(experienceId) !== -1
      ? setIsLiked(true)
      : setIsLiked(false);
  };

  useEffect(() => {
    infoContent.experienceId && setExperienceId(infoContent.experienceId);
    updateIsLikeState();
  }, [experienceId]);

  const onLikeClick = () => {
    if (experienceId === null) return;

    const storage = JSON.parse(localStorage.getItem('likedExperiences'));
    if (storage.some(item => item === experienceId)) {
      if (storage.indexOf(experienceId) !== -1) {
        storage.splice(storage.indexOf(experienceId), 1);

        localStorage.setItem('likedExperiences', JSON.stringify(storage));

        return updateIsLikeState();
      }
    } else {
      storage.push(experienceId);

      localStorage.setItem('likedExperiences', JSON.stringify(storage));

      return updateIsLikeState();
    }
  };

  const onQuestionLike = question => {
    questionLike.update({
      experience: experienceName,
      category: infoContent.categoryLink,
      question,
    });
  };

  // TODO: ... to this, and delete local storage funcitonality at all

  return (
    <StyledContainer>
      {infoContent && Object.keys(infoContent).length && (
        <>
          <StyledHeader>
            {infoContent.title && (
              <StyledHeading>
                {size > 991 && (
                  <StyledBackButton onClick={onClick}>
                    <span className="sr-only">Go back</span>
                    <Icon.Arrow aria-hidden />
                  </StyledBackButton>
                )}
                <StyledTitle>{infoContent.title}</StyledTitle>
              </StyledHeading>
            )}
            <StyledSaveButton type="button" onClick={onLikeClick}>
              {isLiked ? <Icon.HeartBig aria-hidden /> : <Icon.HeartOutline aria-hidden />}
              <span className="sr-only">
                {`${infoContent.isSaved ? 'Unfollow' : 'Follow'} this experience.`}
              </span>
            </StyledSaveButton>
          </StyledHeader>
          <StyledContentWrapper>
            {infoContent.description && (
              <StyledDescription>{infoContent.description}</StyledDescription>
            )}
            {infoContent.categoryLink && (
              <CategoryLink
                link={infoContent.categoryLink.link || '/'}
                color={infoContent.categoryLink.color || 'blue'}
                name={infoContent.categoryLink.name}
              />
            )}
          </StyledContentWrapper>
        </>
      )}
      <StyledContentWrapper>
        {questions && Object.keys(questions).length && (
          <InfoTabs data={questions} onQuestionLike={onQuestionLike} />
        )}
      </StyledContentWrapper>
    </StyledContainer>
  );
}

ExperienceInfo.propTypes = {
  infoContent: PropTypes.shape({
    title: PropTypes.string,
    isSaved: PropTypes.bool,
    description: PropTypes.string,
    categoryLink: PropTypes.shape({
      link: PropTypes.string.isRequired,
      color: PropTypes.string,
      name: PropTypes.string.isRequired,
    }),
  }),
  questions: PropTypes.shape({
    title: PropTypes.string,
    questions: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        title: PropTypes.string.isRequired,
        questions: PropTypes.arrayOf(PropTypes.string),
      })
    ),
  }),
};

export default ExperienceInfo;
